module.exports = __webpack_public_path__ + "static/media/55_000015.fa98b7f8.jpg";